import { query, redirect } from '@solidjs/router';
import { getRequestEvent } from 'solid-js/web';
import { getRequestURL } from '~/utils/host';

function parseCookie(cookie: string | null | undefined) {
  if (!cookie) return null;
  return cookie.split(';').reduce(
    (acc, c) => {
      const [key, value] = c.split('=');
      acc[key.trim()] = value;
      return acc;
    },
    {} as Record<string, string>
  );
}

function checkValidUserToken(token?: string) {
  return token && token.length > 0;
}

export const validateUser = query(async () => {
  const event = getRequestEvent();
  if (!event) return;

  const url = getRequestURL();

  if (
    url?.pathname.startsWith('/tenants/auth') ||
    url?.pathname === '/tenants/privacy-policy' ||
    url?.pathname === '/tenants/terms-of-service'
  )
    return;

  const parsedCookie = parseCookie(event?.request.headers.get('cookie'));

  if (!checkValidUserToken(parsedCookie?.userToken)) {
    throw redirect('/tenants/auth/signin');
  }
}, 'validateUser');
